import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShoppingCart, Check } from 'lucide-react';
import { useCart } from '../context/CartContext';

const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

const FitnessDeals = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [addedItems, setAddedItems] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const deals = [
    {
      id: 1,
      title: 'מארז אבקות חלבון',
      description: '3 אבקות במחיר מיוחד',
      price: 599,
      badge: 'מבצע חם!',
      badgeColor: 'bg-[#D97706]',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/x2osrvyh_cf2c16_590054b640fa4338a8c3115c16f61c11~mv2.avif'
    },
    {
      id: 2,
      title: '2 חלבונים + שייקר מתנה',
      description: 'שני חלבוני מי גבינה איכותיים + שייקר במתנה!',
      price: 499,
      badge: 'מבצע חם!',
      badgeColor: 'bg-red-500',
      image: 'https://images.unsplash.com/photo-1693996045838-980674653385?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxwcm90ZWluJTIwcG93ZGVyJTIwc2hha2VyJTIwYm90dGxlJTIwZml0bmVzcyUyMHN1cHBsZW1lbnR8ZW58MHx8fHwxNzc1NDgzMjA4fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 3,
      title: 'חלבון + קדם אימון',
      description: 'חבילת אימון מושלמת - חלבון + קדם אימון',
      price: 349,
      badge: 'מבצע חם!',
      badgeColor: 'bg-[#D97706]',
      image: 'https://images.unsplash.com/photo-1768161680813-615df885ff82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxwcmUlMjB3b3Jrb3V0JTIwc3VwcGxlbWVudCUyMHBvd2RlciUyMGd5bXxlbnwwfHx8fDE3NzU0ODMyMDl8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 4,
      title: 'קראטין + קדם אימון + חלבון',
      description: 'חבילת הכל כלול + שייקר מתנה!',
      price: 499,
      badge: 'חבילה + שייקר מתנה!',
      badgeColor: 'bg-green-600',
      image: 'https://images.unsplash.com/photo-1693996045899-7cf0ac0229c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxwcm90ZWluJTIwcG93ZGVyJTIwc2hha2VyJTIwYm90dGxlJTIwZml0bmVzcyUyMHN1cHBsZW1lbnR8ZW58MHx8fHwxNzc1NDgzMjA4fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 5,
      title: '2 חלבונים + קדם אימון',
      description: 'שני חלבונים איכותיים + קדם אימון לביצועים מקסימליים',
      price: 449,
      badge: 'מבצע חם!',
      badgeColor: 'bg-red-500',
      image: 'https://images.unsplash.com/photo-1704650311981-419f841421cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxwcmUlMjB3b3Jrb3V0JTIwc3VwcGxlbWVudCUyMHBvd2RlciUyMGd5bXxlbnwwfHx8fDE3NzU0ODMyMDl8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 6,
      title: 'חטיפי חלבון אול אין 38 גרם',
      description: '9 חטיפי חלבון 38 גרם + ה-10 חינם!',
      price: 153,
      badge: '9+1 חינם!',
      badgeColor: 'bg-purple-600',
      image: 'https://images.unsplash.com/photo-1772986509919-61b14bf702fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxwcm90ZWluJTIwYmFycyUyMHNuYWNrJTIwZml0bmVzcyUyMGhpZ2glMjBwcm90ZWlufGVufDB8fHx8MTc3NTQ4MzIxMXww&ixlib=rb-4.1.0&q=85'
    }
  ];

  const handleButtonClick = (deal) => {
    if (addedItems[deal.id]) {
      navigate('/cart');
    } else {
      addToCart({
        id: `fitness-deal-${deal.id}`,
        name: deal.title,
        description: deal.description,
        price: deal.price,
        image: deal.image,
        quantity: 1
      });
      
      playCartSound();
      setAddedItems(prev => ({ ...prev, [deal.id]: true }));
      setShowPopup(true);
      
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    }
  };

  return (
    <div className="container py-8" data-testid="fitness-deals-page">
      {/* Popup */}
      {showPopup && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-bounce">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}

      {/* Back Button */}
      <button
        onClick={() => navigate('/fitness')}
        className="flex items-center gap-2 text-[#2C3E2D] hover:text-[#D97706] transition-colors mb-8"
        data-testid="back-button"
      >
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה למוצרים</span>
      </button>

      {/* Title */}
      <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] text-center mb-10" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="deals-title">
        מבצעים חמים
      </h1>

      {/* Deals Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {deals.map((deal) => (
          <div
            key={deal.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden border-4 border-[#D97706] flex flex-col transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            data-testid={`deal-${deal.id}`}
          >
            {/* Badge */}
            <div className={`${deal.badgeColor || 'bg-[#D97706]'} text-white text-center py-2`}>
              <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {deal.badge || 'מבצע חם!'}
              </span>
            </div>
            
            {/* Image */}
            <div className="p-4 bg-white flex-shrink-0">
              <img
                src={deal.image}
                alt={deal.title}
                className="w-full h-48 object-contain mx-auto"
              />
            </div>

            {/* Content */}
            <div className="px-4 py-3 text-center flex-1">
              <h3 className="text-lg font-bold text-[#2C3E2D] mb-1" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {deal.title}
              </h3>
              <p className="text-sm text-stone-600">
                {deal.description}
              </p>
            </div>

            {/* Price and Button */}
            <div className="p-4 bg-stone-50 text-center">
              <div className="text-3xl font-bold text-[#D97706] mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {deal.price} ש"ח
              </div>
              <button
                onClick={() => handleButtonClick(deal)}
                className={`w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full font-bold text-lg transition-all duration-300 ${
                  addedItems[deal.id]
                    ? 'bg-green-500 text-white hover:bg-green-600'
                    : 'bg-[#D97706] text-white hover:bg-[#B45309]'
                } hover:shadow-lg`}
                style={{ fontFamily: 'Heebo, sans-serif' }}
                data-testid={`checkout-deal-${deal.id}`}
              >
                <ShoppingCart className="w-5 h-5" />
                {addedItems[deal.id] ? 'מעבר לרכישה' : 'הוסף לסל'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FitnessDeals;
